export const FUNDING_PORTAL = {
  alpha: "alpha.funding.apn.a2z.com",
  beta: "beta.funding.apn.a2z.com",
  gamma: "gamma.funding.apn.a2z.com",
  preprod: "preprod.funding.apn.a2z.com",
  prod: "funding.apn.a2z.com",
};

export const AWS_ACCOUNT_ID_DEFAULT = "000000000000";
